import React from 'react';
import * as Sentry from '@sentry/browser';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import {Link, Redirect} from "react-router-dom";
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

import googleLogo from '../google_g.svg';
import {styles} from '../styles';
import {redirectToGoogleSSO, parametersFromCookiesAndQuery} from '../utils';
import {requestPubnubApiPOST, withCredentials} from '../apiClient';
import ErrorSnackbar from './ErrorSnackbar';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitErrorText: '',
      showErrorSnackbar: false,
      disabled: false,
    };
  }

  handleSubmit = () => {
    this.setState({disabled: true});
    return withCredentials(requestPubnubApiPOST)(
      '/me',
      {
        body: {
          properties: parametersFromCookiesAndQuery(),
          ...this.props.credentials,
        }
      }
    ).then(response => {
      const { result } = response.body;
      if (result.reason && result.reason === 'UNVERIFIED_EMAIL') {
        this.props.history.push('/confirm-email')
        return
      }
      const userId = result.user.id;
      const sessionToken = result.token;
      this.props.login(sessionToken, userId, result.user);
      this.setState({disabled: false});

      Sentry.setUser({id: userId})
    }).catch(error => {
      if (error.response) {
        this.setState({
          submitErrorText: error.response.body.message || error.response.body.error,
          showErrorSnackbar: true,
        });
      } else {
        this.setState({
          submitErrorText: 'Something unexpected happen, please try again later',
          showErrorSnackbar: true,
        });
      }
      this.setState({disabled: false});
    });
  };

  handleErrors = errors => {
    // console.log(errors);
  };

  closeSnackbar = () => {
    this.setState({
      ...this.state,
      showErrorSnackbar: false,
    })
  };

  forgotPasswordLink = () => `${window.location.hostname.endsWith('.pubnub.com') ? 'https://admin.pubnub.com/' : 'https://admin.ingress.caravan.integration.ps.pn/'}#/forgot-password/${this.props.credentials.email}`;

  render() {
    if (this.props.loggedIn) {
      return <Redirect to={'/activate-pubsub'} />
    }
    return (
      <div className="App" style={{margin: "0 auto"}}>
        <Grid container spacing={8}>
          <Grid item xs>
            <img alt="PubNub" src="pubnub.png" style={{width: "100px"}}/>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="title" gutterBottom className={this.props.classes.title}>
              Login
            </Typography>
            <div>
              <Button onClick={redirectToGoogleSSO} variant="contained" className={this.props.classes.loginWithGoogle}>
                <img alt="Google g logo" src={googleLogo} className={this.props.classes.googleLogo}/>
                Login with Gmail
              </Button>
            </div>
            <div className={this.props.classes.divider}>
              Or Login with Email
            </div>
            <div>
              <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
                onError={this.handleErrors}
              >
                <TextValidator
                  name="login-email"
                  id="login-email-input"
                  label="Email Address"
                  value={this.props.credentials.email}
                  onChange={this.props.handleChange('email')}
                  fullWidth
                  className={this.props.classes.textfield}
                  validators={['required', 'isEmail']}
                  errorMessages={['this field is required', 'email is not valid']}
                  disabled={this.state.disabled}
                />
                <TextValidator
                  name="login-passworad"
                  id="login-password-input"
                  label="Password"
                  type="password"
                  value={this.props.credentials.password}
                  onChange={this.props.handleChange('password')}
                  fullWidth
                  className={this.props.classes.textfield}
                  validators={['required']}
                  errorMessages={['this field is required']}
                  disabled={this.state.disabled}
                />
                <Button
                  id="loginButton"
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={this.props.classes.button}
                  disabled={this.state.disabled}
                >
                  {this.state.disabled ?
                    <CircularProgress size={21} className={this.props.classes.buttonCircularProgress}/> : 'Login'}
                </Button>
              </ValidatorForm>
              <a href={ this.forgotPasswordLink() } target="_blank" className={this.props.classes.forgotPasswordLink}>Forgot password?</a>
            </div>
          </Grid>
          <Grid item xs>
            <Link to={`/signup${window.location.search}`} className={this.props.classes.link}>Sign Up for a Free Account</Link>
          </Grid>
        </Grid>
        <ErrorSnackbar
          message={this.state.submitErrorText}
          open={this.state.showErrorSnackbar}
          onClose={this.closeSnackbar}
        />
      </div>
    )
  }
}

export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/componentes/Login.js